import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { Duplication, Item, Type } from '@/store/models/duplication';
import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import limit from '@/store/modules/limit';
import auth from '@/store/modules/auth';
import { Limit } from '@/store/models/limit';
import store from '@/store';
import { t } from '@/i18n/i18n';
import notifier from '@/_helpers/notifier';
import template from './DuplicationPopup.vue';

@Component({
	mixins: [template],
	components: {
		ValidationObserver,
		MDTextFieldWithValidation
	}
})
export default class DuplicationPopup extends Vue {
	@Prop() show!: false;

	@Prop({ required: true }) item!: '';

	@Prop() title!: '';

	@Prop() message!: '';

	@Prop() cancelText!: '';

	@Prop() confirmText!: '';

	@Prop() hideConfirm!: false;

	loadingLimits: boolean = false;

	radioButtons = [
		{
			key: 'take',
			label: t('general.duplicate-take')
		},
		{
			key: 'duplicate',
			label: t('general.duplicate-duplicate')
		},
		{
			key: 'ignore',
			label: t('general.duplicate-ignore')
		}
	];

	duplication: Duplication = {
		item: null,
		amount: 1,
		types: []
	};

	mounted(): void {
		switch (this.item as Item) {
			case Item.ADVERTISEMENT:
				this.duplication.types.push({ item: Item.QRCODE, type: Type.TAKE, title: t('general.qr-codes') });
				break;
			case Item.QRLINK:
				this.duplication.types.push({ item: Item.QRCODE, type: Type.TAKE, title: t('general.qr-codes') });
				break;
			case Item.QRCODE:
				this.duplication.types.push({ item: Item.QRLINK, type: Type.TAKE, title: t('general.qr-links') });
				this.duplication.types.push({ item: Item.ADVERTISEMENT, type: Type.TAKE, title: t('general.advertisements') });

				this.getLimit();
				break;
			default:
				break;
		}
	}

	async getLimit(): Promise<void> {
		this.loadingLimits = true;
		try {
			await auth.getSelf(false);
			await Promise.all([limit.getCustomer(auth.self.customerId), limit.getProject(this.$route.params.Pid)]);
		} catch (error) {
			notifier.error('getting', 'data');
		} finally {
			this.loadingLimits = false;
		}
	}

	get limitCustomer(): Limit | null {
		return limit.limitCustomer;
	}

	get limitProject(): Limit | null {
		return limit.limitProject;
	}

	cancel(): void {
		this.$emit('cancel');
	}

	duplicate(): void {
		if (!(this.$refs.duplicationPopupForm as any).validate()) {
			return;
		}
		this.duplication.amount = parseInt((this.duplication.amount as unknown) as string, 10);
		this.$emit('duplicate', this.duplication);
	}

	get beDisabled(): boolean {
		if (
			(this.item as Item) === Item.QRCODE &&
			this.limitCustomer !== undefined &&
			this.limitCustomer.used !== undefined &&
			this.limitCustomer.total !== undefined &&
			this.limitProject !== undefined &&
			this.limitProject.used !== undefined &&
			this.limitProject.total !== undefined
		) {
			return (
				this.limitProject.total.qrCodes - this.limitProject.used.qrCodes < 1 ||
				this.limitCustomer.total.qrCodes - this.limitCustomer.used.qrCodes < 1
			);
		}
		return false;
	}

	get getAmountRules(): string {
		if (
			(this.item as Item) === Item.QRCODE &&
			this.limitCustomer !== undefined &&
			this.limitCustomer.used !== undefined &&
			this.limitCustomer.total !== undefined &&
			this.limitProject !== undefined &&
			this.limitProject.used !== undefined &&
			this.limitProject.total !== undefined
		) {
			return `|maxQRCodesProject:${this.limitProject.total.qrCodes - this.limitProject.used.qrCodes}|maxQRCodesCustomer:${this
				.limitCustomer.total.qrCodes - this.limitCustomer.used.qrCodes}`;
		}
		return '';
	}
}
